import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
// import homeImg from '../../../../Assets/Images/WhatsMyFood/Home.png';
import articleMediumImg from '../../../../Assets/Images/Content/ArticleMedium.jpeg';
import comingSoonArticle from '../../../../Assets/Images/Content/Soon1.gif';
// import addRestaurantImg from '../../../../Assets/Images/WhatsMyFood/AddRestaurant.png';
// import addFoodImg from '../../../../Assets/Images/WhatsMyFood/AddFood.png';
import presentationImg from '../../../../Assets/Images/Content/Presentation.jpeg';
import device from '../../../../Assets/Responsive/breakpoints';

const Medium = styled.img.attrs({
  style: ({ scroll }) => ({
    transform: `translate(0px,-${scroll * 15}%)`
  })
})`
  transition: transform 0.2s ease-out;
  position: absolute;
  bottom: -170vh;
  left: 0vw;
  /* border: 1px dashed red; */
  height: 80vh;
  border-radius: 42px;
  @media ${device.mobileMaxWidth} {
    transform-origin: right center;
    height: 60vh;
    bottom: -150vh;
    border-radius: 34px;
  }
`;

const ComingSoon = styled.img.attrs({
  style: ({ scroll }) => ({
    transform: `translate(0px,-${scroll * 5}%) scale(0.9)`
  })
})`
  transition: transform 0.2s ease-out;
  position: absolute;
  height: 90vh;
  bottom: -75vh;
  right: 2vw;
  //   border: 1px dashed red;
  border-radius: 40px;
  @media ${device.mobileMaxWidth} {
    transform-origin: right center;
    height: 60vh;
    right: 0vw;
    bottom: -100vh;
    border-radius: 34px;
  }
`;
// const Centeredtext = styled.h1`
//   margin: auto;
// `;

const Presentation = styled.img.attrs({
  style: ({ scroll }) => ({
    transform: `translate(0px,-${scroll * 5}%) scale(0.7)`
  })
})`
  transition: transform 0.2s ease-out;
  bottom: -95vh;
  left: 0vw;
  position: absolute;
  /* border: 1px dashed red; */
  height: 60vh;
  /* filter: blur(0.8px); */
  @media ${device.mobileMaxWidth} {
    transform-origin: left center;
    height: 40vh;
    bottom: -110vh;
    border-radius: 16px;
  }
`;

// const AddRestaurant = styled.img.attrs({
//   style: ({ scroll }) => ({
//     transform: `translate(0px,-${scroll * 2}%) scale(0.6)`,
//   }),
// })`
//   transition: transform 0.2s ease-out;
//   bottom: -55vh;
//   right: 5vw;
//   position: absolute;
//   /* border: 1px dashed red; */
//   height: 80vh;
//   filter: blur(1.2px);
// `;

class ArticleImages extends Component {
  render() {
    let { scrollPercent } = this.props;
    const { boxHeight, index, scrollHeight, screenHeight } = this.props;
    const heighttoBeReducedinVH = boxHeight * index - 100;
    const scrollOffset = (screenHeight * heighttoBeReducedinVH) / 100;
    const scrollOffsetInPercent = (scrollOffset * 100) / scrollHeight + index - 1;
    // console.log('WMF scrollOffsetPercent ', scrollOffsetInPercent);
    scrollPercent -= scrollOffsetInPercent;
    return (
      <React.Fragment>
        {/* <AddFood src={addFoodImg} scroll={scrollPercent} alt="addFood" /> */}
        <Presentation src={presentationImg} scroll={scrollPercent} alt="addRestaurant" />
        <a
          href="https://dev.to/dorbellmas/expose-yourself-to-the-open-source-world-please-2jlk"
          target="_blank"
          rel="noopenner noreferrer"
        >
          <ComingSoon src={comingSoonArticle} scroll={scrollPercent} alt="ComingSoon" />
        </a>
        <a
          href="https://medium.com/@dorbellmas/how-to-enrich-your-abilities-with-the-open-source-world-now-c38501a9d43c"
          target="_blank"
          rel="noopenner noreferrer"
        >
          {' '}
          <Medium src={articleMediumImg} scroll={scrollPercent} alt="Medium" />
        </a>
      </React.Fragment>
    );
  }
}

ArticleImages.propTypes = {
  boxHeight: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  screenHeight: PropTypes.number.isRequired,
  scrollHeight: PropTypes.number.isRequired,
  scrollPercent: PropTypes.number.isRequired
};

export default ArticleImages;
